$(document).ready(function () {
  const search = $('.plays-list__search-input')

  if (search) {
    search.on("change", function (e) {
      console.log(e.target.value)
    });
  }
})
